<script lang="ts">
import FichePointages from '@/generated/fiches/FichePointages.vue';
import { Extended } from '@/framework/base/classes/Schema';
import { defineComponent } from "vue";

export default defineComponent({
  components: {},
  extends: FichePointages,
  methods: {
    isDisplayed(value: string): boolean {
      if (value == 'TRANSACTIONS') {
        this.setExtended(new Extended('TRANSACTIONS', this.fiche, true));
      }
      return true;
    }
  }
})

</script>
